import { EvtHeader } from "components/header";
import EntityForm from "@/modules/organization/entities/crud/form";
import React from "react";
import { useParams } from "react-router-dom";

const UpdateEntity = () => {
    const { entityId } = useParams();
    return (
        <div className="flex-1">
            <EvtHeader title="Update Entity" />
            <div className="p-6 max-w-md">
                <EntityForm entityId={entityId} />
            </div>
        </div>
    );
};

export default UpdateEntity;
